import { useTheme } from 'styled-components';
import * as S from './styles';
import Cartaz from '@/components/atoms/Cartaz';
import Text from '@/components/atoms/Text';
import useBreakpoint from '@/hooks/useBreakpoint';
import { IconeCoracao } from '@/components/atoms/Icones/IconeCoracao';
import { IconeRelogio } from '@/components/atoms/Icones/IconeRelogio';
import RadioCardItem from '../RadioCardItem';

export type BotaoEscolherPlaylistProps = {
  $tipo: 'favoritos' | 'verDepois' | 'lista';
  $imagem: string;
  $nome: string;
  $descricao: string;
  $selecionado: boolean;
  $onClick: () => void;
};

export default function BotaoEscolherPlaylist(
  props: BotaoEscolherPlaylistProps,
) {
  const { $tipo, $imagem, $nome, $descricao, $selecionado, $onClick, ...rest } =
    props;
  const theme = useTheme();
  const { breakpoint } = useBreakpoint();

  return (
    <S.ContainerBotao onClick={$onClick} {...rest}>
      <RadioCardItem
        $size={2}
        $variant="outline"
        $color="neutral"
        $highContrast={false}
        $state={$selecionado ? 'checked' : 'default'}
        $useRadioIcon
        style={{
          alignItems: 'center',
        }}
        $iconPosition="end"
      >
        <S.Row>
          {$tipo === 'lista' ? (
            <Cartaz
              $tamanho="extraPequeno"
              src={$imagem}
              alt={`Cartaz de capa da lista ${$nome} `}
              style={{ marginRight: theme.spacing[4] }}
            />
          ) : (
            <S.ContainerIcone>
              {$tipo === 'favoritos' ? (
                <IconeCoracao
                  size={30}
                  color={theme.tokens.colors.white_contrast}
                />
              ) : (
                <IconeRelogio
                  size={30}
                  color={theme.tokens.colors.white_contrast}
                />
              )}
            </S.ContainerIcone>
          )}

          <div
            style={{
              gap: theme.spacing[3],
              flexDirection: 'column',
              display: 'flex',
            }}
          >
            <Text
              $size={breakpoint === 'mobile' ? 2 : 4}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text={$nome}
            />
            <Text
              $size={1}
              $color="neutral"
              $weight="regular"
              $align="left"
              $highContrast={true}
              $text={$descricao}
            />
          </div>
        </S.Row>
      </RadioCardItem>
    </S.ContainerBotao>
  );
}
